import { combineReducers } from "redux";
import {
  ADVERTISEMENT_ANALYTICS_DATALIST,
  ADVERTISEMENT_CLICKANALYTICS_DATALIST,
  ADVERTISEMENT_ANALYTICS_COUNT
} from "AdvertisementinsightActions";

export function advertisementviewAnalyticsdatalist(
  state = [],
  action
) {
  switch (action.type) {
    case ADVERTISEMENT_ANALYTICS_DATALIST:
      return action.payload;
    default:
      return state;
  }
}

export function advertisementclickAnalyticsdatalist(
  state = [],
  action
) {
  switch (action.type) {
    case ADVERTISEMENT_CLICKANALYTICS_DATALIST:
      return action.payload;
    default:
      return state;
  }
}
export function advertisementAnalyticscounts(
  state = [],
  action
) {
  switch (action.type) {
    case ADVERTISEMENT_ANALYTICS_COUNT:
      return action.payload;
    default:
      return state;
  }
}